import React from "react";
import { FiSave } from "react-icons/fi";

const SaveIcon = FiSave;

const StickyActionBar = ({ t, saving, disabled, onCancel, onSave }) => (
  <div className="sticky bottom-[5.4rem] z-30 mt-6 rounded-[1.35rem] bg-white/90 p-2 shadow-[0_0.9rem_2rem_rgba(15,23,42,0.12)] backdrop-blur dark:border dark:border-slate-700/80 dark:bg-slate-900/90 dark:shadow-black/30">
    <div className="grid grid-cols-2 gap-3">
      <button
        type="button"
        onClick={onCancel}
        disabled={saving}
        className="inline-flex min-h-11 items-center justify-center rounded-xl border border-emerald-700/55 bg-white px-4 text-[0.9rem] font-black text-emerald-700 disabled:cursor-not-allowed disabled:opacity-60 dark:border-emerald-700/70 dark:bg-slate-800 dark:text-emerald-300"
      >
        {t("common.cancel", { defaultValue: "Cancel" })}
      </button>

      <button
        type="button"
        onClick={onSave}
        disabled={saving || disabled}
        className="inline-flex min-h-11 items-center justify-center gap-2 rounded-xl bg-emerald-600 px-4 text-[0.9rem] font-black text-white shadow-[0_0.8rem_1.45rem_rgba(5,150,105,0.24)] transition hover:bg-emerald-500 disabled:cursor-not-allowed disabled:opacity-55"
      >
        <SaveIcon className="h-4 w-4 shrink-0" aria-hidden="true" />
        <span className="leading-tight">
          {saving
            ? "..."
            : t("privacy.save_changes", {
                defaultValue: "Save changes",
              })}
        </span>
      </button>
    </div>
  </div>
);

export default StickyActionBar;
